import { z } from 'zod';

const tradePanelFormSchema = z.object({
  orderType: z.enum(['buy', 'sell']),
  limitPrice: z
    .string()
    .min(0, 'Price is required')
    .refine(
      (val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0,
      'Price must be a positive number'
    ),
  quantity: z
    .string()
    .min(0, 'Quantity is required')
    .refine(
      (val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0,
      'Quantity must be a positive number'
    ),
  total: z
    .string()
    .min(0, 'Total is required')
    .refine(
      (val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0,
      'Total must be a positive number'
    ),
});

export type TradePanelFormValues = z.infer<typeof tradePanelFormSchema>;
export { tradePanelFormSchema };

export const ORDER_TYPE_STYLES = {
  buy: 'bg-bullish hover:bg-bullish/90 text-white',
  sell: 'bg-bearish hover:bg-bearish/90 text-white',
} as const;
